import React from "react";
import { DatePicker } from "antd";
import moment, { Moment } from "moment";
import dayjs, { Dayjs } from "dayjs";

const { RangePicker } = DatePicker;

interface PredefinedDateRangesProps {
  startDate: Moment;
  endDate: Moment;
  onDateChange: (start: Moment, end: Moment) => void;
}

const PredefinedDateRangesOneMonth: React.FC<PredefinedDateRangesProps> = ({
  startDate,
  endDate,
  onDateChange,
}) => {

  const handleDateChange = (
    dates: [Dayjs | null, Dayjs | null] | null
  ) => {
    if (dates && dates[0] && dates[1]) {
      onDateChange(
        moment(dates[0].toDate()),
        moment(dates[1].toDate())
      );
    }
  };

  const ranges: Record<string, [Dayjs, Dayjs]> = {
    Today: [dayjs(), dayjs()],
    Yesterday: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
    "Last 7 Days": [dayjs().subtract(6, "day"), dayjs()],
    "Last 30 Days": [dayjs().subtract(29, "day"), dayjs()],
    "This Month": [dayjs().startOf("month"), dayjs().endOf("month")],
    "Last Month": [
      dayjs().subtract(1, "month").startOf("month"),
      dayjs().subtract(1, "month").endOf("month"),
    ],
  };

  return (
    <RangePicker
      value={[dayjs(startDate.toDate()), dayjs(endDate.toDate())]}
      onChange={handleDateChange}
      format="DD/MM/YYYY"
      ranges={ranges}
      allowClear={false}
      style={{ width: "100%" }}
    />
  );
};

export default PredefinedDateRangesOneMonth;
